/*
    Create by Pierre Marsot on 05/12/2017
*/
import {
    REMOVE_BALISE_ERROR,
    REMOVE_BALISE_SUCCESS,
    LOAD_BALISE_SUCCESS,
    LOAD_BALISE_ERROR,
    LOAD_USERS_BALISE_ERROR,
    LOAD_USERS_BALISE_SUCCESS,
    DISSOCIER_UTILISATEUR_BALISE_SUCCESS,
    DISSOCIER_UTILISATEUR_BALISE_ERROR,
    DECLENCHER_BALISE_ERROR,
    DECLENCHER_BALISE_SUCCESS,
    ARRETER_BALISE_ERROR,
    ARRETER_BALISE_SUCCESS
} from '../actions/balise';

let inittialeState = {
    balise: null,
    usersBalise: [],
};

export default function detailBalise(state = inittialeState, action = {}){
    let balise = null;
    switch(action.type){
        case DECLENCHER_BALISE_SUCCESS:
            if(!state.balise || state.balise === null) {
                return state;
            }

            balise = Object.assign({}, state.balise);
            balise._source.en_alerte = true;

            return {
                ...state,
                balise: balise,
            };

        case DECLENCHER_BALISE_ERROR:
            return state;

        case ARRETER_BALISE_SUCCESS:
            if(!state.balise || state.balise === null) {
                return state;
            }

            balise = Object.assign({}, state.balise);
            balise._source.en_alerte = false;

            return {
                ...state,
                balise: balise,
            };

        case ARRETER_BALISE_ERROR:
            return state;

        case LOAD_USERS_BALISE_ERROR:
            return {
                ...state,
                usersBalise: [],
            };

        case LOAD_USERS_BALISE_SUCCESS:
            if(!action || !action.users_balise){
                return {
                    ...state,
                    usersBalise: [],
                };
            }

            return {
                ...state,
                usersBalise: action.users_balise,
            };

        case REMOVE_BALISE_SUCCESS:
            if(!action || !action.id_balise){
                return state;
            }

            if(state.balise === null){
                return state;
            }

            if(state.balise._id !== action.id_balise){
                return state;
            }

            return {
                ...state,
                balise: null,
            };

        case LOAD_BALISE_SUCCESS:
            if(!action || !action.balise){
                return {
                    ...state,
                    balise: null,
                }
            }

            return {
                ...state,
                balise: action.balise,
            };

        case DISSOCIER_UTILISATEUR_BALISE_SUCCESS:
            if(!action || !action.id_user){
                return state;
            }

            return {
                ...state,
                usersBalise: state.usersBalise.filter((u) => {
                    return u._id !== action.id_user;
                })
            };

        case LOAD_BALISE_ERROR:
        case REMOVE_BALISE_ERROR:
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/detailBalise.js